"use strict";

exports.__esModule = true;
exports.default = exports.Text = exports.StyledText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _breakpoints = require("../../../helpers/breakpoints");

var _polished = require("polished");

var _Markdown = _interopRequireDefault(require("../Markdown/Markdown"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledText = ({
  children,
  tag,
  theme,
  lead,
  // destructure text style props to prevent them being passed to the DOM element
  playback,
  body,
  small,
  primaryValue,
  secondaryValue,
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  light,
  regular,
  medium,
  bold,
  primary,
  secondary,
  danger,
  warning,
  markdown,
  ...otherProps
}) => {
  const Tag = tag;
  return markdown ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Tag, { ...otherProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Markdown.default, {
      removeWrapper: true,
      children: children
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Tag, { ...otherProps,
    children: children
  });
};

exports.StyledText = StyledText;
const inlineTags = ["span", "strong", "em", "i"];

const getTextStyle = (breakpoint, props) => {
  let fontSize, fontWeight, lineHeight, fontColor, marginBottom, marginTop; // If the tag is set and it matches an inline tag then return different rules

  if (props.tag && inlineTags.indexOf(props.tag) !== -1) {
    fontSize = "inherit";
    lineHeight = "inherit";
    fontWeight = props.tag === "strong" ? props.theme.fontWeights.bold : "inherit";
    fontColor = "inherit";
    return `font-size: ${fontSize}; font-weight: ${fontWeight}; line-height: ${lineHeight}; color: ${fontColor};`;
  } // get font size


  if (breakpoint === "xs") {
    if (props.lead) fontSize = props.theme.fontSizes[4];else if (props.playback) fontSize = props.theme.fontSizes[3];else if (props.body) fontSize = props.theme.fontSizes[3];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[8];else if (props.secondaryValue) fontSize = props.theme.fontSizes[6];else if (props.h1) fontSize = props.theme.fontSizes[10];else if (props.h2) fontSize = props.theme.fontSizes[8];else if (props.h3) fontSize = props.theme.fontSizes[6];else if (props.h4) fontSize = props.theme.fontSizes[5];else if (props.h5) fontSize = props.theme.fontSizes[4];else fontSize = props.theme.fontSizes[3];
  } else if (breakpoint === "sm") {
    if (props.lead) fontSize = props.theme.fontSizes[5];else if (props.playback) fontSize = props.theme.fontSizes[4];else if (props.body) fontSize = props.theme.fontSizes[4];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[8];else if (props.secondaryValue) fontSize = props.theme.fontSizes[6];else if (props.h1) fontSize = props.theme.fontSizes[10];else if (props.h2) fontSize = props.theme.fontSizes[8];else if (props.h3) fontSize = props.theme.fontSizes[6];else if (props.h4) fontSize = props.theme.fontSizes[5];else if (props.h5) fontSize = props.theme.fontSizes[4];else fontSize = props.theme.fontSizes[4];
  } else if (breakpoint === "md") {
    if (props.lead) fontSize = props.theme.fontSizes[5];else if (props.playback) fontSize = props.theme.fontSizes[4];else if (props.body) fontSize = props.theme.fontSizes[4];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[9];else if (props.secondaryValue) fontSize = props.theme.fontSizes[7];else if (props.h1) fontSize = props.theme.fontSizes[11];else if (props.h2) fontSize = props.theme.fontSizes[9];else if (props.h3) fontSize = props.theme.fontSizes[7];else if (props.h4) fontSize = props.theme.fontSizes[6];else if (props.h5) fontSize = props.theme.fontSizes[5];else fontSize = props.theme.fontSizes[4];
  } else if (breakpoint === "lg") {
    if (props.lead) fontSize = props.theme.fontSizes[5];else if (props.playback) fontSize = props.theme.fontSizes[4];else if (props.body) fontSize = props.theme.fontSizes[4];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[10];else if (props.secondaryValue) fontSize = props.theme.fontSizes[8];else if (props.h1) fontSize = props.theme.fontSizes[12];else if (props.h2) fontSize = props.theme.fontSizes[10];else if (props.h3) fontSize = props.theme.fontSizes[8];else if (props.h4) fontSize = props.theme.fontSizes[7];else if (props.h5) fontSize = props.theme.fontSizes[6];else fontSize = props.theme.fontSizes[4];
  } else if (breakpoint === "xl") {
    if (props.lead) fontSize = props.theme.fontSizes[5];else if (props.playback) fontSize = props.theme.fontSizes[4];else if (props.body) fontSize = props.theme.fontSizes[4];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[10];else if (props.secondaryValue) fontSize = props.theme.fontSizes[8];else if (props.h1) fontSize = props.theme.fontSizes[12];else if (props.h2) fontSize = props.theme.fontSizes[10];else if (props.h3) fontSize = props.theme.fontSizes[8];else if (props.h4) fontSize = props.theme.fontSizes[7];else if (props.h5) fontSize = props.theme.fontSizes[6];else fontSize = props.theme.fontSizes[4];
  } else {
    // default sizes for screen widths smaller than xxs
    if (props.lead) fontSize = props.theme.fontSizes[4];else if (props.playback) fontSize = props.theme.fontSizes[3];else if (props.body) fontSize = props.theme.fontSizes[3];else if (props.small) fontSize = props.theme.fontSizes[3];else if (props.primaryValue) fontSize = props.theme.fontSizes[8];else if (props.secondaryValue) fontSize = props.theme.fontSizes[6];else if (props.h1) fontSize = props.theme.fontSizes[10];else if (props.h2) fontSize = props.theme.fontSizes[8];else if (props.h3) fontSize = props.theme.fontSizes[6];else if (props.h4) fontSize = props.theme.fontSizes[5];else if (props.h5) fontSize = props.theme.fontSizes[4];else fontSize = props.theme.fontSizes[3];
  } // get font weight


  if (props.light) fontWeight = props.theme.fontWeights.light;else if (props.regular) fontWeight = props.theme.fontWeights.regular;else if (props.medium) fontWeight = props.theme.fontWeights.medium;else if (props.bold) fontWeight = props.theme.fontWeights.bold;else if (props.lead) fontWeight = props.theme.fontWeights.medium;else if (props.playback) fontWeight = props.theme.fontWeights.regular;else if (props.body) fontWeight = props.theme.fontWeights.regular;else if (props.small) fontWeight = props.theme.fontWeights.light;else if (props.primaryValue) fontWeight = props.theme.fontWeights.light;else if (props.secondaryValue) fontWeight = props.theme.fontWeights.light;else if (props.h1) fontWeight = props.theme.fontWeights.bold;else if (props.h2) fontWeight = props.theme.fontWeights.bold;else if (props.h3) fontWeight = props.theme.fontWeights.bold;else if (props.h4) fontWeight = props.theme.fontWeights.bold;else if (props.h5) fontWeight = props.theme.fontWeights.bold;else fontWeight = props.theme.fontWeights.regular; // get line height

  if (props.lead) lineHeight = props.theme.lineHeights.copy;else if (props.playback) lineHeight = props.theme.lineHeights.copy;else if (props.body) lineHeight = props.theme.lineHeights.copy;else if (props.small) lineHeight = props.theme.lineHeights.copy;else if (props.primaryValue) lineHeight = props.theme.lineHeights.copy;else if (props.secondaryValue) lineHeight = props.theme.lineHeights.copy;else if (props.h1) lineHeight = props.theme.lineHeights.title;else if (props.h2) lineHeight = props.theme.lineHeights.title;else if (props.h3) lineHeight = props.theme.lineHeights.title;else if (props.h4) lineHeight = props.theme.lineHeights.title;else if (props.h5) lineHeight = props.theme.lineHeights.title;else lineHeight = props.theme.lineHeights.copy; // get font color

  if (props.primary) fontColor = props.theme.colors.primaryText;else if (props.secondary) fontColor = props.theme.colors.secondaryText;else if (props.danger) fontColor = props.theme.colors.danger;else if (props.warning) fontColor = props.theme.colors.warning;else fontColor = "inherit"; // get margin-top and margin-bottom (as percentage of font-size)

  const [value, unit] = (0, _polished.getValueAndUnit)(fontSize);
  const units = unit ? unit : "px";

  if (props.tag && props.tag.indexOf("h") === 0) {
    marginTop = `${Math.ceil(value * props.theme.headings.marginTop)}${units}`;
    marginBottom = `${Math.ceil(value * props.theme.headings.marginBottom)}${units}`;
  } else {
    marginTop = `${Math.ceil(value * props.theme.paragraphs.marginTop)}${units}`;
    marginBottom = `${Math.ceil(value * props.theme.paragraphs.marginBottom)}${units}`;
  }

  return `font-size: ${fontSize}; font-weight: ${fontWeight}; line-height: ${lineHeight}; color: ${fontColor}; margin-bottom: ${marginBottom}; margin-top: ${marginTop};`;
};

const isNotInlineTag = props => {
  return !props.tag || props.tag && inlineTags.indexOf(props.tag) === -1;
};

const Text = (0, _styledComponents.default)(StyledText)`
  line-height: ${({
  theme
}) => theme.lineHeights.copy};

  margin-top: 0;
  ${props => getTextStyle(null, props)};

  ${props => isNotInlineTag(props) && _breakpoints.breakpointUp.xs`
        ${getTextStyle("xs", props)};
    `}

  ${props => isNotInlineTag(props) && _breakpoints.breakpointUp.sm`
        ${getTextStyle("sm", props)};
    `}

    ${props => isNotInlineTag(props) && _breakpoints.breakpointUp.md`
        ${getTextStyle("md", props)};
    `}

    ${props => isNotInlineTag(props) && _breakpoints.breakpointUp.lg`
        ${getTextStyle("lg", props)};
    `}

    ${props => isNotInlineTag(props) && _breakpoints.breakpointUp.xl`
        ${getTextStyle("xl", props)};
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.position}
`;
exports.Text = Text;
Text.displayName = 'Text';
Text.propTypes = {
  tag: _propTypes.default.string,
  lead: _propTypes.default.bool,
  playback: _propTypes.default.bool,
  body: _propTypes.default.bool,
  small: _propTypes.default.bool,
  primaryValue: _propTypes.default.bool,
  secondaryValue: _propTypes.default.bool,
  h1: _propTypes.default.bool,
  h2: _propTypes.default.bool,
  h3: _propTypes.default.bool,
  h4: _propTypes.default.bool,
  h5: _propTypes.default.bool,
  p: _propTypes.default.bool,
  light: _propTypes.default.bool,
  regular: _propTypes.default.bool,
  medium: _propTypes.default.bool,
  bold: _propTypes.default.bool,
  primary: _propTypes.default.bool,
  secondary: _propTypes.default.bool,
  danger: _propTypes.default.bool,
  warning: _propTypes.default.bool,
  markdown: _propTypes.default.bool,
  children: _propTypes.default.node
};
Text.defaultProps = {
  tag: "p"
};
var _default = Text;
exports.default = _default;